import { createSlice } from "@reduxjs/toolkit";
import { removeTagAction, tagsCreateAction, tagsListAction, tagsSchoolListAction, tagsUpdateAction } from "../Action/TagsAction";


const initialState = {
   tags:{},
   tagsSchoolList:{},
   faqCreateStatus:"idle",
   tagsUpdateStatus:"idle",
   removeTagActionStatus:"idle",
}

const tagsSlice = createSlice({
    name: 'tags',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(tagsListAction.fulfilled, (state, action) => {
                state.tags = action?.payload?.data;  
            })        
            .addCase(tagsSchoolListAction.fulfilled, (state, action) => {
                state.tagsSchoolList = action?.payload?.data;  
            }) 

            .addCase(tagsCreateAction.fulfilled, (state, action) => {
                state.faqCreateStatus = 'succeeded';
            })        


            .addCase(tagsUpdateAction.fulfilled, (state, action) => {
                state.tagsUpdateStatus = 'succeeded';
            })     
            
            .addCase(removeTagAction.fulfilled, (state, action) => {
                state.removeTagActionStatus = 'succeeded';
            })     
            
            
    },
});

export default tagsSlice.reducer;






